import { Amplify } from 'aws-amplify'

// Export API URL for use in other files
// Remove extra quotes from environment variables due to JSON.stringify in vite.config.ts
// Also ensure API_URL doesn't have a trailing slash
export const API_URL = process.env.REACT_APP_API_URL 
  ? process.env.REACT_APP_API_URL.replace(/^"|"$/g, '').replace(/\/$/, '') 
  : '';
export const REGION = process.env.REACT_APP_REGION ? process.env.REACT_APP_REGION.replace(/^"|"$/g, '') : 'us-west-2';
export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID ? process.env.REACT_APP_USER_POOL_ID.replace(/^"|"$/g, '') : '';
export const USER_POOL_WEB_CLIENT_ID = process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID ? process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID.replace(/^"|"$/g, '') : '';

// Log configuration values for debugging
console.log('AWS Configuration:', {
  API_URL,
  REGION,
  USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID
});

export const configureAmplify = () => {
  try {
    // Check network connectivity first
    console.log('Checking network connectivity...');
    
    // Configure Amplify
    const config = {
      // Auth configuration
      Auth: {
        Cognito: {
          userPoolId: USER_POOL_ID,
          userPoolClientId: USER_POOL_WEB_CLIENT_ID,
          // Identity Pool removed as it's not needed and was causing errors
          loginWith: {
            oauth: {
              domain: (process.env.REACT_APP_OAUTH_DOMAIN || '').replace(/^"|"$/g, '') || 'evd-ask-ed.auth.us-west-2.amazoncognito.com',
              scopes: ['email', 'profile', 'openid'],
              redirectSignIn: [window.location.origin + '/'],
              redirectSignOut: [window.location.origin + '/'],
              responseType: 'code' as 'code'
            }
          }
        }
      },
      // API configuration
      API: {
        REST: {
          chatApi: {
            endpoint: API_URL,
            region: REGION
          }
        }
      },
      // Storage configuration for S3
      Storage: {
        S3: {
          buckets: {
            'evd-prd-web-stage': {
              region: REGION,
              bucketName: 'evd-prd-web-stage'
            }
          }
        }
      }
    };
    
    // Log the full configuration (but mask sensitive values)
    const sanitizedConfig = JSON.parse(JSON.stringify(config));
    if (sanitizedConfig.Auth?.Cognito?.userPoolClientId) {
      sanitizedConfig.Auth.Cognito.userPoolClientId = sanitizedConfig.Auth.Cognito.userPoolClientId.substring(0, 5) + '...';
    }
    console.log('Amplify Configuration:', JSON.stringify(sanitizedConfig, null, 2));
    
    // Configure Amplify with the configuration
    Amplify.configure(config);
    
    // Verify configuration was applied
    console.log('Amplify configured successfully');
    
    // Add global error handler for fetch/network errors
    const originalFetch = window.fetch;
    window.fetch = async function(input, init) {
      try {
        const response = await originalFetch(input, init);
        return response;
      } catch (error) {
        console.error('Network error in fetch:', error);
        console.error('Request details:', { 
          url: typeof input === 'string' ? input : input instanceof Request ? input.url : 'unknown',
          method: init?.method || 'GET'
        });
        throw error;
      }
    };
    
  } catch (error) {
    console.error('Error configuring Amplify:', error);
    // Display a user-friendly error message
    const errorDiv = document.createElement('div');
    errorDiv.style.position = 'fixed';
    errorDiv.style.top = '0';
    errorDiv.style.left = '0';
    errorDiv.style.right = '0';
    errorDiv.style.padding = '10px';
    errorDiv.style.backgroundColor = 'red';
    errorDiv.style.color = 'white';
    errorDiv.style.textAlign = 'center';
    errorDiv.style.zIndex = '9999';
    errorDiv.textContent = 'Failed to initialize application. Please check your network connection and try again.';
    document.body.appendChild(errorDiv);
  }
}
